<template>
    <div>
        <p>Вы можете использовать персональный ключ <code>{{ apiKey }}</code> для проверки карт через наш API.</p>
        <p>Пример получения информации:</p>
        <code>curl -v -d 'member=1111365&name=ARTUR%20NIKONOV' https://tracker.aopa.ru/api/members/verifyMember?api_key={{ apiKey }}</code>
        <p></p>
        <p>Ответом является JSON-объект со следующими полями:</p>
        <ul>
            <li><i>member</i> — номер карты</li>
            <li><i>name</i> — имя и фамилия латиницей (как на карте)</li>
            <li><i>expires</i> — дата окончания действия карты (всегда первое число месяца, следующего за месяцем из графы <i>Expires</i> карты)</li>
            <li><i>status</i> — числовое значение актуальности карты: «1» — карта действительна, «3» — срок действия карты истёк</li>
        </ul>
        <p>Если член с таким номером карты не найден или номер карты не совпадает с дополнительной переданной информацией, то возвращается код <i>404 Not Found</i>:</p>
        <code>curl -v -d 'member=1111365&name=IVAN%20IVANOV' https://tracker.aopa.ru/api/members/verifyMember?api_key={{ apiKey }}</code>
        <p></p>
        <p>Если в качестве дополнительной информации используется не фамилия, а адрес электронной почты, то передавать его следует в параметре <i>email</i>:</p>
        <code>curl -v -d 'member=1111365&email=test@test.ru' https://tracker.aopa.ru/api/members/verifyMember?api_key={{ apiKey }}</code>
    </div>
</template>

<script>
export default {
    props: {
        apiKey: String
    }
}
</script>
